import * as Cookie from "js-cookie";
import config from "../config.json";
import { environment } from "../environment";

const ENV: string = environment;
const envConfig = (config as any)[ENV];

export const userService = {
  getCurrentUser: (): string | null => {
    if (envConfig && envConfig.hasOwnProperty("user")) {
      return envConfig.user;
    } else if (Cookie.get("userId") && Cookie.get("userId") !== "") {
      return Cookie.get("userId") || null;
    } else {
      return null;
    }
  },
};
